import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

// Async thunk to start/stop a VM
export const updateAWSVmState = createAsyncThunk(
  "aws/updateAWSVmState",
  async ({ accountId, resourceId, action }, { rejectWithValue }) => {
    try {
      const res = await httpInterceptor.post(
        `/resources/aws/ec2?account=${accountId}&instance=${resourceId}&action=${action}`
      );
      // Assuming API returns updated VM object
      return { accountId, vm: res.data };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update VM state"
      );
    }
  }
);

// Initial state
const initialState = {
  loading: false,
  updatedVm: null, // updated VM after API call
  error: false,
  errorMessage: "",
};

const updateAWSVmStateSlice = createSlice({
  name: "updateAWSVmState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateAWSVmState.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.errorMessage = "";
        state.updatedVm = null;
      })
      .addCase(updateAWSVmState.fulfilled, (state, action) => {
        state.loading = false;
        state.updatedVm = action.payload; // contains accountId + updated vm object
      })
      .addCase(updateAWSVmState.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errorMessage = action.payload;
        state.updatedVm = null;
      });
  },
});

export default updateAWSVmStateSlice.reducer;
